import React from 'react';
import CapturaNueva from '../Venta/CapturaNueva';

export default function AfterCaptura() {
    return (
        <div className="modal" id="afterCaptura" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div className="modal-dialog modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Añadir otras capturas</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <CapturaNueva IsEspecial={true}/>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" >Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
